import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpRepositoryResponse } from './http-repository-response';
import { AFToken } from './af-token';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpRepositoryService {

  readonly headerName: string = '__RequestVerificationToken';

  constructor(private http: HttpClient, @Inject('BASE_URL') private readonly baseUrl: string, private router: Router) { }

  public get<TType>(apiUri: string): Observable<HttpRepositoryResponse<TType>> {
    return this.http.get<TType>(this.baseUrl + apiUri).pipe(
      map(x => new HttpRepositoryResponse<TType>(x)),
      catchError((err: HttpErrorResponse) => this._catchError<TType>(err)));
  }

  public post<TType>(apiUri: string, data: any, afToken: AFToken = null): Observable<HttpRepositoryResponse<TType>> {
    var headers = new HttpHeaders().set(this.headerName, afToken.token);

    return this.http.post<TType>(this.baseUrl + apiUri, data, { headers: headers}).pipe(
      map(x => new HttpRepositoryResponse<TType>(x)),
      catchError((err: HttpErrorResponse) => this._catchError<TType>(err)));
  }

  public put<TType>(apiUri: string, data: any, afToken: AFToken = null): Observable<HttpRepositoryResponse<TType>> {
    var headers = new HttpHeaders().set(this.headerName, afToken.token);

    return this.http.put<TType>(this.baseUrl + apiUri, data, { headers: headers}).pipe(
      map(x => new HttpRepositoryResponse<TType>(x)),
      catchError((err: HttpErrorResponse) => this._catchError<TType>(err)));
  }

  public del(apiUri: string, afToken: AFToken = null): Observable<HttpRepositoryResponse<any>> {
    var headers = new HttpHeaders().set(this.headerName, afToken.token);

    return this.http.delete(this.baseUrl + apiUri, { headers: headers }).pipe(
      map(x => new HttpRepositoryResponse<any>({})),
      catchError((err: HttpErrorResponse) => this._catchError(err))
    );
  }
  
  private _catchError<TType>(error: HttpErrorResponse): Observable<HttpRepositoryResponse<TType>> {
    var resp = new HttpRepositoryResponse<TType>(null);
    resp.hasErrors = true;
    resp.error = 'Ops! Some error had occurred. Please refresh the page.';
    resp.statusCode = error.status;

    if (resp.statusCode == 401) {
      window.open('/', '_self');
    }

    if (resp.statusCode == 403) {
      this.router.navigate(['/unauthorized']);
    }

    if (resp.statusCode == 404) {
      this.router.navigate(['/notfound']);
    }

    return of(resp);
  }
}
